<div style="color: #fff; width: 600px; margin: 0 auto; padding: 80px;">

    <div>{{ 'buttonConfiguration.title' | translate }}</div>

    <div style="display: flex; margin: 20px;">
        <button appButton
            type="button" class="inactive"
            [ngClass]="{'success': configType===Limit.NL}"
            (click)="changeConfigType()">
            {{ 'buttonConfiguration.limits.noLimit' | translate }}
        </button>
        <button appButton
            type="button" class="inactive"
            [ngClass]="{'success': configType===Limit.PL}"
            (click)="changeConfigType()">
            {{ 'buttonConfiguration.limits.potLimit' | translate }}
        </button>
    </div>
    <div>
        <form [formGroup]="configType===Limit.NL ? btnConfigNL : btnConfigPL">
            <div formGroupName="preFlop">
                <div
                    style="font-weight: 500; text-align: center; margin-bottom: 10px;border-bottom: 1px #fff solid;">{{ 'buttonConfiguration.sections.preFlop' | translate }}</div>
                <table style="width: 100%;">
                    <tr>
                        <td>{{ 'buttonConfiguration.buttons.buttonA' | translate }}</td>
                        <td>
                            <select formControlName="btn1">
                                <option
                                    [value]="preFlopBtnOption.value"
                                    *ngFor="let preFlopBtnOption of (configType===Limit.NL ? btn1ConfigNLPreFlopBtnOptions$ : btn1ConfigPLPreFlopBtnOptions$)|async">
                                    {{preFlopBtnOption.label}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'buttonConfiguration.buttons.buttonB' | translate }}</td>
                        <td>
                            <select formControlName="btn2">
                                <option
                                    [value]="preFlopBtnOption.value"
                                    *ngFor="let preFlopBtnOption of (configType===Limit.NL ? btn2ConfigNLPreFlopBtnOptions$ : btn2ConfigPLPreFlopBtnOptions$)|async">
                                    {{preFlopBtnOption.label}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'buttonConfiguration.buttons.buttonC' | translate }}</td>
                        <td>
                            <select formControlName="btn3">
                                <option
                                    [value]="preFlopBtnOption.value"
                                    *ngFor="let preFlopBtnOption of (configType===Limit.NL ? btn3ConfigNLPreFlopBtnOptions$ : btn3ConfigPLPreFlopBtnOptions$)|async">
                                    {{preFlopBtnOption.label}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </table>
            </div>

            <div formGroupName="postFlop" style="margin: 50px 0 0 0;">
                <div
                    style="font-weight: 500; text-align: center; margin-bottom: 10px; border-bottom: 1px #fff solid;">{{ 'buttonConfiguration.sections.postFlop' | translate }}</div>
                <table style="width: 100%;">
                    <tr>
                        <td>{{ 'buttonConfiguration.buttons.buttonA' | translate }}</td>
                        <td>
                            <select formControlName="btn1">
                                <option
                                    [value]="postFlopBtnOption.value"
                                    *ngFor="let postFlopBtnOption of (configType===Limit.NL ? btn1ConfigNLPostFlopBtnOptions$ : btn1ConfigPLPostFlopBtnOptions$)|async">
                                    {{postFlopBtnOption.label}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'buttonConfiguration.buttons.buttonB' | translate }}</td>
                        <td>
                            <select formControlName="btn2">
                                <option
                                    [value]="postFlopBtnOption.value"
                                    *ngFor="let postFlopBtnOption of (configType===Limit.NL ? btn2ConfigNLPostFlopBtnOptions$ : btn2ConfigPLPostFlopBtnOptions$)|async">
                                    {{postFlopBtnOption.label}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'buttonConfiguration.buttons.buttonC' | translate }}</td>
                        <td>
                            <select formControlName="btn3">
                                <option
                                    [value]="postFlopBtnOption.value"
                                    *ngFor="let postFlopBtnOption of (configType===Limit.NL ? btn3ConfigNLPostFlopBtnOptions$ : btn3ConfigPLPostFlopBtnOptions$)|async">
                                    {{postFlopBtnOption.label}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </table>
            </div>

            <div
                style="display: flex; width: 100%; margin-top: 20px; justify-content: center;">
                <button appButton
                    type="button" class="secondary"
                    (click)="reset()">
                    {{ 'buttonConfiguration.actions.reset' | translate }}
                </button>
                <button appButton class="succes"
                    type="button"
                    (click)="save()">
                    {{ 'buttonConfiguration.actions.save' | translate }}
                </button>

            </div>
        </form>
    </div>
    <div style="position: absolute; right: 10px; bottom: 10px;" *ngIf="false">
        <div style="font-size: 10px;">
            <h2>btnConfigNL</h2>
            <pre>{{btnConfigNL.value|json}}</pre>
        </div>
        <div style="font-size: 10px;">
            <h2>btnConfigPL</h2>
            <pre>{{btnConfigPL.value|json}}</pre>
        </div>
    </div>
</div>